import { useEffect, useState } from 'react';
import { CurrencyUtils } from '@shared/utils';

export const useCurrencySymbol = (code: string | undefined) => {
  const [currencySymbol, setCurrencySymbol] = useState('');

  useEffect(() => {
    if (!code) {
      setCurrencySymbol('');
      return;
    }

    const item = CurrencyUtils.getSymbolByCode(code);
    setCurrencySymbol(item);
  }, [code]);

  return currencySymbol;
};
